import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles, getRelatedArticles } from '@/mocks/articles';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function HomePage() {
  const featuredArticles = articles.slice(0, 6);

  const faqItems = [
    {
      question: '自慰会对身体造成伤害吗？',
      answer: '适度自慰不会对身体造成伤害。科学研究表明，自慰是正常且健康的性行为之一。只有当频率过高影响日常生活、力度过大导致组织损伤、或不注意卫生引发感染时，才可能带来健康问题。',
    },
    {
      question: '自慰频率多少算正常？',
      answer: '没有统一的标准频率。每个人的性欲水平、身体状况和生活环境不同，自慰频率也自然有所差异。判断的关键是：是否影响正常生活、是否引起身体不适、是否产生心理负担。',
    },
    {
      question: '女性自慰正常吗？',
      answer: '完全正常。女性自慰是了解自身身体和性反应的健康方式。调查显示绝大多数女性在一生中都有过自慰经历。社会对女性自慰的污名化源于性别偏见，没有科学依据。',
    },
    {
      question: '自慰会导致早泄或勃起功能障碍吗？',
      answer: '目前没有循证医学证据证明自慰直接导致早泄或勃起功能障碍。适度的自慰反而有助于了解自身性反应模式。但如果习惯性地追求快速高潮，可能形成不利于伴侣性行为的射精模式。',
    },
    {
      question: '如何判断自己是否自慰过度？',
      answer: '可以从以下几个方面判断：生殖器是否持续不适、自慰后是否极度疲劳影响正常活动、是否因自慰而逃避社交或工作、是否即使没有性欲也强迫自慰、尝试减少频率但无法做到。如出现以上情况，建议寻求专业帮助。',
    },
    {
      question: '自慰前后需要注意哪些卫生问题？',
      answer: '自慰前应使用流动水和肥皂彻底清洗双手，修剪指甲。自慰后应及时用温水清洗外阴区域，女性注意从前向后清洗。建议自慰后排尿一次以降低尿路感染风险。如有使用情趣用品，需在使用前后彻底清洁。',
    },
  ];

  const faqSchemaData = {
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question' as const,
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer' as const,
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="FAQPage" additionalData={faqSchemaData} />

      <div className="min-h-screen bg-background-50">
        {/* Hero Section */}
        <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
          <img
            src="https://mastinfo.github.io/api/search-image?query=Warm%20minimalist%20abstract%20wellness%20illustration%20with%20soft%20cream%20and%20terracotta%20gradient%20flowing%20organic%20shapes%2C%20gentle%20healing%20atmosphere%2C%20calm%20medical%20wellness%20aesthetic%2C%20no%20text%2C%20abstract%20peaceful%20composition%2C%20warm%20natural%20tones%2C%20soft%20diffused%20light&width=1920&height=900&seq=hero-health-01&orientation=landscape"
            alt="自慰方式完全指南 - 健康科普"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
          <div className="absolute inset-0 flex items-center justify-center px-4 md:px-6">
            <div className="text-center max-w-3xl">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
                自慰方式完全指南
              </h1>
              <p className="text-base md:text-xl text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto">
                安全、健康与愉悦的全面解析——科学认识自慰方式，建立正确的性健康观念
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/anquan-xuzhi"
                  className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap"
                >
                  开始探索
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white rounded-full text-sm font-medium transition-all duration-300 backdrop-blur-sm whitespace-nowrap"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Category Grid */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                探索分类
              </h2>
              <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
                选择你感兴趣的主题，开始科学、健康的自我认知之旅
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-white border border-background-200/70 rounded-xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300"
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${cat.color}`}>
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors" style={{ fontFamily: 'var(--font-heading)' }}>
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                精选文章
              </h2>
              <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
                由医学专家和科普作者精心撰写，为你提供最专业的性健康知识
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {featuredArticles.map((article) => {
                const cat = categories.find((c) => c.slug === article.category);
                return (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={article.imageUrl}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-3 mb-2 flex-wrap">
                        {cat && (
                          <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full whitespace-nowrap">
                            {cat.name}
                          </span>
                        )}
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                      </div>
                      <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2" style={{ fontFamily: 'var(--font-heading)' }}>
                        {article.title}
                      </h3>
                      <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                        <span>{article.author}</span>
                        <span>·</span>
                        <span>{article.date}</span>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
            <div className="text-center mt-10">
              <Link
                to="/category/anquan-xuzhi"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-100 text-secondary-700 hover:bg-secondary-200 rounded-full text-sm font-medium transition-colors whitespace-nowrap"
              >
                浏览全部文章
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                常见问题
              </h2>
              <p className="text-foreground-600 text-sm md:text-base">
                关于自慰方式，你可能有的疑问都在这里
              </p>
            </div>
            <div className="space-y-3">
              {faqItems.map((faq, i) => (
                <details key={i} className="group bg-white border border-background-200/70 rounded-xl overflow-hidden">
                  <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                    <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.question}</span>
                    <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </summary>
                  <div className="px-6 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-gradient-to-br from-primary-500 to-primary-700">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              开启健康的自我认知之旅
            </h2>
            <p className="text-white/85 mb-8 text-sm md:text-base leading-relaxed">
              科学认识自慰方式，拥抱身体的自主权。我们提供专业、客观、全面的性健康知识，帮助你建立积极健康的自我认知。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/jiankang-zhidao"
                className="px-8 py-3 bg-white text-primary-700 hover:bg-background-50 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap"
              >
                浏览健康指导
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white rounded-full text-sm font-medium transition-all duration-300 backdrop-blur-sm whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}